import styled from 'styled-components';
import { isElectron } from '../../utils';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  height: ${isElectron() ? 'calc(100% - 38px)' : '100%'};
  align-items: ${({ centeredContent }) => (centeredContent ? 'center' : 'normal')};
`;
